import { FDBox, FDContentContainer, FDStack } from '@facet-wealth/design';
import React, { useEffect } from 'react';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import useMobileLayout from 'Hooks/useMobileLayout';
import Footer from 'Components/ClientApp/Desktop/Footer';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const useStyles = buildUseStyles('ReferralPage', () => ({
  footer: {
    position: 'sticky',
    transform: 'initial',
    bottom: 'unset',
  },
  wrapText: {
    wordWrap: 'break-word',
  },
}));

export const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const classes = useStyles();
  // const [lastEvent, setLastEvent] = React.useState(null);
  // const [events, setEvents] = React.useState([]);

  useBoneBackgroundColor();

  useEffect(() => {
    const messageListener = (ev) => {
      if (ev.data && ev.data.type === 'exitApril') {
        // eslint-disable-next-line no-console
        console.log('exiting...', ev);
      }
      if (ev.data && ev.data.type === 'onUserActivity') {
        // eslint-disable-next-line no-console
        console.log('user activity...', ev);
        // setLastEvent(ev);
        // setEvents((prev) => [ev, ...prev]);
      }
    };

    window.addEventListener('message', messageListener);

    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, []);


  return (
    <>
      <FDContentContainer maxWidth={'xl'}>
        <FDStack direction={'row'} flexGrow={1}>
          <FDBox flex={1} padding={2}>
            <iframe
              title={'Tax Filing Partner'}
              src={resource.relationship(fr.relationships.partnerUrl.name).link('related').url()}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                minHeight: '1000px',
              }}
            />
          </FDBox>
          {/* <FDStack direction={'column'} spacing={2} flex={1} padding={2}> */}
          {/*  <FDStack direction={'column'} spacing={2}> */}
          {/*    <FDBodyText value={'Current Event:'} /> */}
          {/*    <FDPaper padding={2} flex={1}> */}
          {/*      <ReadOnlyJsonObjectView jsonObject={lastEvent?.data} /> */}
          {/*    </FDPaper> */}
          {/*  </FDStack> */}
          {/*  <FDStack direction={'column'} spacing={2}> */}
          {/*    <FDBodyText value={'Past Events:'} /> */}
          {/*    {events.map((event, idx) => ( */}
          {/*      <FDPaper padding={2} flex={1}> */}
          {/*        <ReadOnlyJsonObjectView key={event.timestamp || idx} jsonObject={event?.data} /> */}
          {/*      </FDPaper> */}
          {/*    ))} */}

          {/*  </FDStack> */}

          {/* </FDStack> */}
        </FDStack>
      </FDContentContainer>
      {!isMobile && <Footer className={classes.footer} />}
    </>
  );
};
